import { useEffect, useContext } from "react";
import { AppContext } from "../../context/AppContext"; // adjust path as needed
import { Navigate } from "react-router-dom";

const AuthLogoff = () => {
  const { logout } = useContext(AppContext);

  useEffect(() => {
    logout();
    // You could also trigger logout directly here without Navigate,
    // but using Navigate below ensures redirection if context is async
  }, [logout]);

  return <Navigate to="/auths/auth-login" replace />;
};

export default AuthLogoff;


// import { Navigate } from "react-router-dom";
// import { useEffect } from "react";

// const AuthLogoff = () => {

//   useEffect(()=>{
//     localStorage.clear();
//   },[])  

//   return (
//     <Navigate to="/auths/auth-login" />
//   )
// }

// export default AuthLogoff